import api from "@/api";

export default {
    namespaced: true,

    actions: {

        async fetchServiceRequestsAdminData(context) {
            const url = `/admin/service-requests-data`
            const response = await api.request("get", url);
            return response.data;
        },

        async fetchServiceRequests(context, {page, s, type, place_id}) {
            const url = `/admin/service-requests?page=${page}&type=${type}&s=${s}&place_id=${place_id}`
            const response = await api.request("get", url);
            return response.data;
        },

        async deleteServiceRequest(context, item) {
            const url = `/admin/service-requests/${item.uid}`;
            return await api.request('delete', url);
        },

        async deleteServiceRequestImage(context, body) {
            const url = `/admin/service-requests/${body.service_request_guid}/images/${body.image_guid}`;
            return await api.request('delete', url)
        },

        async sendLog(context, {action, srv_id, additional_data}) {
            try {
                const url = '/api/anon/service-requests/log'
                let body = {
                    srv_id: srv_id,
                    action: action,
                    date: (new Date()).toISOString(),
                    additional_data: additional_data,
                }
                const response = await api.request("post", url, body)
                return response.data;
            } catch (error) {
                console.log(`unable to send log:`, error)
                return ':('
            }
        },

        async addRequest(context, body) {
            const prefix = context.rootState.auth.accessToken ? 'v1' : 'anon'
            let url = `/api/${prefix}/service-requests`
            let formData = new FormData();
            formData.append('srv_id', body.srv_id);
            formData.append('question_guid', body.question_guid);
            formData.append('type', body.type);
            formData.append('name', body.name);
            formData.append('phone', body.phone);
            formData.append('data', JSON.stringify(body.data));
            formData.append('location[lat]', body.location.lat);
            formData.append('location[lng]', body.location.lng);
            formData.append('location[accuracy]', body.location.accuracy);
            formData.append('notes', body.notes);
            formData.append('audio', body.audio);
            for (var i = 0; body.images.length > i; i++) {
                formData.append('file[]', body.images[i]);
            }
            try {
                const response = await api.request("post", url, formData);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async getInitialData(context, data) {
            const prefix = context.rootState.auth.accessToken ? 'v1' : 'anon'
            const url = `/api/${prefix}/service-requests/initialData?q_guid=${data.guid}&type=${data.type}`
            const response = await api.request("get", url);
            return response.data
        },

        async entryPointInitialData(context, data) {
            const prefix = context.rootState.auth.accessToken ? 'v1' : 'anon'
            let url = `/api/${prefix}/sr-entry/initialData?o_guid=${data.org_guid}&type=${data.type}`
            if(data.place_guid) {
                url += `&p_guid=${data.place_guid}`
            }
            const response = await api.request("get", url);
            return response.data
        },
    }
}
